import * as React from "react";
import Select from "react-select";
import { Classification } from "../../FeralScan.dtos";
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import { IAppState } from "../../app";
import * as AdminActionCreators from "../../actions/admin.actions";
import Loader from "react-loaders";

export interface IPlotMetaUserInfoSelectOption {
    label: string;
    value: string;
}

type PlotMetaUserInfoSelectProps = {
    className?: string;
    disabled?: boolean;
    onChange: any;
    plotMetaInfoPropertyKey: string;
    value: any;
}

type PlotMetaUserInfoSelectActions = {}

type PlotMetaUserInfoSelectPropsMapped = {
    plotMetaInfo: string[];
    plotMetaInfoLoading: boolean;
}

type PlotMetaUserInfoSelectActionsMapped = {
    getPlotMetaInfo: typeof AdminActionCreators.getPlotMetaInfoRequest;
}

type PlotMetaUserInfoSelectAllPropsInherited = PlotMetaUserInfoSelectProps & PlotMetaUserInfoSelectActions;
type PlotMetaUserInfoSelectAllPropsMapped = PlotMetaUserInfoSelectPropsMapped & PlotMetaUserInfoSelectActionsMapped;
type PlotMetaUserInfoSelectAllProps = Partial<PlotMetaUserInfoSelectAllPropsMapped> & PlotMetaUserInfoSelectAllPropsInherited;

class PlotMetaUserInfoSelect extends React.PureComponent<PlotMetaUserInfoSelectAllProps, any> {
    componentDidMount() {
        if(!this.props.plotMetaInfoLoading && !this.props.plotMetaInfo) {
            this.props.getPlotMetaInfo();
        }
    }

    render() {

        const options = this.props.plotMetaInfo ? this.props.plotMetaInfo.map((mInfo, i) => ({ label: mInfo, value: mInfo })) : [];

        return (
            this.props.plotMetaInfoLoading
                ? <div className="col-md-10">
                    <Loader type="line-scale" active />
                </div>
                : <Select
                    isDisabled={this.props.disabled}
                    options={options}
                    value={this.props.value}
                    onChange={this.props.onChange}
                    isSearchable={true}
                    isClearable={true}
                />
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: PlotMetaUserInfoSelectAllProps): PlotMetaUserInfoSelectPropsMapped => {
    var data = [];
    var attribute = ownProps.plotMetaInfoPropertyKey.split(".")[1];
    if(state.admin.plotMetaInfo) {
        state.admin.plotMetaInfo.users.map(user => {
            data.push(user[attribute]);
        });
    }
    data = data.filter(d => d != null);
    data = [ ...new Set(data)];
    data = data.sort();
    return {
        plotMetaInfo: data,
        plotMetaInfoLoading: state.admin.plotMetaInfoLoading
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators<PlotMetaUserInfoSelectActionsMapped>({
        getPlotMetaInfo: AdminActionCreators.getPlotMetaInfoRequest,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PlotMetaUserInfoSelect);